<template>
    <div :class="phoneClass">
        <div class="login-header">
            <index-header>
                <div class="slot-content">
                    {{$t('header.register')}}
                </div>
            </index-header>
        </div>
        <div class="login-content" @keyup.enter="login">
            <div class="content-form">
                <div class="select-type">
                    <h2>{{$t('header.register')}}</h2>
                </div>
                <div class="input-area">
                    <div class="input-floor">
                        <p class="key">{{$t('loginPage.email')}}</p>
                        <el-input v-model="loginForm.account"
                                  @change="check"
                                  :placeholder="$t('loginPage.email')"></el-input>
                        <!--<div  style="height: 15px;color: red;position: relative;left: 15px;"><span v-if="checkShow">{{msg}}</span></div>-->
                    </div>
                    <div class="input-floor">
                        <p class="key">{{$t('loginPage.password')}}</p>
                        <el-input v-model="loginForm.password"
                                  type="password"
                                  @change="checkPassword"
                                  :placeholder="$t('loginPage.password')"></el-input>
                    </div>
                    <div class="input-floor">
                        <p class="key">{{$t('loginPage.verification_code')}}</p>
                        <div class="captcha-floor">
                            <el-input v-model="loginForm.captcha_code" :placeholder="$t('loginPage.verification_code')"></el-input>
                            <img class="captcha-image" :src="captchaImage" @click="getLoginCaptcha">
                        </div>
                    </div>
                </div>
                <el-button type="primary" class="login-button" @click="login">{{$t('registerPage.next')}}</el-button>
                <div class="operation">
                    <p>
                        <span class="normal">
                            {{$t('registerPage.have_account')}}.
                        </span>
                        <span class="green" @click="goLoginPage">
                            {{$t('header.login')}}
                        </span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import IndexHeader from './layout/header'
import Core from "core/core";
const OEM = Core.Const.ROLE_AGENT.OEM;
const AFM = Core.Const.ROLE_AGENT.AFM;
import {refresh} from "core/winSize"
export default {
    data() {
        return {
	        phoneClass: '',
	        loginContainer: '',
            loginForm: {
                account: '',
                password: '',
                captcha_code: ''
            },
            captchaToken: '',
            captchaImage: '',
            type: "",
            msg: '',
            checkShow: true,
            show : false
        };
    },
    components: {
        IndexHeader
    },
    mounted() {
        this.getLoginCaptcha()
    },
    computed: {
    },
    created(){
        this.initShow()

	    refresh(this,'phoneClass-login','login-container');
	    window.onresize = function(){
		    setTimeout(function(){
			    refresh(this,'phoneClass-login','login-container');
		    },10)
	    };
    },
    methods: {
        initShow(){
            this.show = this.$route.query.type
            this.type = this.$route.query.type;
        },
        checkPassword(){
            if(!this.loginForm.password){
                this.$message.error('请输入密码');
                return false
            }
            if(!this.isStrongPassword(this.loginForm.password)){
                this.$message.error('密码至少8位，且必须包含大小写字母、数字和特殊字符');
                return false
            }
            return true
        },
        check(){
            if(this.loginForm.account){
                let email = this.loginForm.account
	            let emailReg = Core.Const.EMAIL_REG
	            if( emailReg.test(email) ){
                    if(this.loginForm.password){
                        this.checkShow = false
                    }
                } else {
                    this.checkShow = true
                    this.$message.error('邮箱格式不正确');
                }
            } else {
                this.checkShow = true
                this.$message.error('请输入邮箱');
            }
        },
        login() {
            this.check()
            if (!this.checkPassword()) {
                return
            }
            if (!this.loginForm.captcha_code) {
                this.$message.error('请输入验证码');
                return
            }
            if (!this.checkShow) {
                let login = this.loginForm;
                window.localStorage.setItem('email',login.account);
                window.localStorage.setItem('password',login.password);
                window.localStorage.setItem('captcha_token',this.captchaToken);
                window.localStorage.setItem('captcha_code',login.captcha_code);
                this.$router.push(`/update-info?user_id=`);
            }
        },
        // 获取注册图片验证码
        getLoginCaptcha() {
            Core.Email.Common.loginCaptcha().then(res => {
                this.captchaToken = res.captcha_token;
                this.captchaImage = res.captcha_image;
                this.loginForm.captcha_code = '';
            })
        },
        // 校验密码强度：至少8位，包含大小写字母、数字和特殊字符
        isStrongPassword(password) {
            return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/.test(password)
        },
        goLoginPage() {
            this.$router.push('/login');
        }
    },


};
</script>

<style scoped lang="scss">
@import '../assets/style/mixin.scss';
.login-container {
    min-height: 100vh;
    width: 100%;
    background: #E5EBEF;
    // background-image: radial-gradient(ellipse farthest-corner at 50% 100%, #263B4E 0%, #1A2936 100%);
    position: relative;
    // padding-top: 1px;
    .login-header {
        .slot-content {
            border-left: 1px solid rgba($color: #000000, $alpha: .3);
            display: inline-block;
            vertical-align: middle;
            font-size: 20px;
            color: #99BEFF;
            line-height: 26px;
            padding-left: 20px;
            font-weight: 500;
        }
    }
    .login-content {
        position: relative;
        height: 500px;
        background-color: #E5EBEF;

        .content-form {
            width: 430px;
            position: absolute;
            background-color: #ffffff;
            padding: 0 0px 40px;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            .select-type {
                h2 {

                    padding-left: 40px;
                    margin-top: 35px;
                    font-size: 24px;
                }
            }
            .title {
                font-size: 24px;
                color: #363D42;
                line-height: 26px;
            }
            .input-area {
                margin-top: 30px;
                margin-bottom: 40px;
                padding: 0 40px;
                    .input-floor {
                        margin-bottom: 20px;
                        .key {
                            font-size: 14px;
                            color: #7A8799;
                            margin-bottom: 6px;;
                        }
                        .captcha-floor {
                            display: flex;
                            align-items: center;
                            .el-input {
                                flex: 1;
                            }
                            .captcha-image {
                                width: 120px;
                                height: 42px;
                                margin-left: 10px;
                                cursor: pointer;
                            }
                        }
                    }
                }
            .login-button {
                width: calc(100% - 80px);
                height: 46px;
                margin:  0 40px;
                span {
                    font-size: 16px;
                }
                color: #FFFFFF;
            }
            .operation {
                margin-top: 50px;
                padding: 0 40px;
                p {
                    font-size: 0;
                    .normal {
                        font-size: 14px;
                        color: #363D42;
                        vertical-align: middle;
                        font-weight: 500;
                    }
                    .green {
                        font-size: 14px;
                        color: #0F58D6;
                        margin-left: 10px;
                        cursor: pointer;
                        vertical-align: middle;
                        font-weight: 500;
                    }
                }
                .operation-floor {
                    .el-button {
                        span {
                            font-size: 14px;
                            color: #0F58D6;
                            line-height: 20px;
                            padding: 10px 19px;
                        }
                    }
                }
            }
        }
    }
}
</style>

<style lang="scss">
.login-content {
    .input-floor {
        .el-input {
            height: 46px;
            .el-input__inner {
                height: 46px;;
            }
        }
    }
}
.operation-floor {
    .el-button {
        span {
            font-size: 14px;
            color: #0F58D6;
            line-height: 20px;
            padding: 4px 3px;
            display: inline-block;
        }
    }
}
.phoneClass-login {
    .el-button {
        width: 100%;
    }
    .el-input__inner {
        height: 30px;
    }
}
.phoneClass-login {
    height: 100vh;
    background: #E5EBEF;
    .login-header {
        .slot-content {
            border-left: 1px solid rgba(0, 0, 0, 0.3);
            color:#99BEFF;
            padding-left: 0.2rem;
            font-size: 0.3rem;
            vertical-align: middle;
            font-weight: 500;
        }
    }
    .login-content {
        width: 100%;
        .content-form {
            width: 70%;
            margin: 30px auto;
            background: white;
            padding: 30px;
            h2 {
                font-size: 24px;
                color: #363D42;
                line-height: 26px;
            }

            .input-area {
                margin-top: 15px;
                margin-bottom: 15px;
                .input-floor{
                    margin-bottom: 20px;
                    p {
                        font-size: 14px;
                        color: #7A8799;
                        margin-bottom: 6px;
                    }
                    .el-input {

                        .el-input__inner {
                            height: 40px;
                        }
                    }
                    .captcha-floor {
                        display: flex;
                        align-items: center;
                        .el-input {
                            flex: 1;
                        }
                        .captcha-image {
                            width: 1.8rem;
                            height: 0.64rem;
                            margin-left: 0.12rem;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
        .operation {
            margin-top: 15px;
            text-align: center;
            font-size: 12px;
            color: #0F58D6;
            font-weight: 500;
            cursor: pointer;
            p {
                margin-bottom: 5px;
            }
        }
    }
}
</style>
